module.exports = __webpack_public_path__ + "static/media/apple_tv_plus_4K_dark__.cd584121.svg";